import React, { MouseEventHandler } from 'react';
import styles from "./DWDButton.module.css";
import { BUTTON_TYPES } from "../../../Common/Constants";
import PlusIcon from "../../../Assets/svgs/plusIcon.svg";
import { Button } from '@mui/material';

export interface DWDButtonProps {
    handleClick: MouseEventHandler;
    title?: string;
    type: BUTTON_TYPES;
    isDisable?: boolean;
    className?: string;
    isPlusIcon?: boolean;
    isHidden?: boolean;
}
const DWDButton = ({
    handleClick,
    title,
    type,
    isDisable,
    className = "",
    isPlusIcon,
    isHidden }: DWDButtonProps) => {

    const handleButtonClick = (event: any) => {
        handleClick && handleClick(event);
    }
    return <Button
        onClick={handleButtonClick}
        className={`${styles[type]} + " " + ${className}`}
        disabled={isDisable}
        hidden={isHidden}
    ><span className="flex-align-items-center-space-evenly">{isPlusIcon && <span><img src={PlusIcon} className="imgSize25 mr10" alt="Plus Icon" /></span>} <span>{title}</span></span></Button>
}

export default DWDButton;